
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("f8bcI", function(module, exports) {

$parcel$export(module.exports, "EmptyView", () => $367a62f961fee563$export$f716ac8971c5316e);

var $eGjK2 = parcelRequire("eGjK2");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bKCrm = parcelRequire("bKCrm");

var $gkT9B = parcelRequire("gkT9B");

var $dPvGX = parcelRequire("dPvGX");

var $99jR2 = parcelRequire("99jR2");

var $lIPB5 = parcelRequire("lIPB5");

var $cSPVK = parcelRequire("cSPVK");

var $hzYon = parcelRequire("hzYon");
const $367a62f961fee563$export$f716ac8971c5316e = ({ dataRef: dataRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'emptyView'
    });
    const [filter] = (0, $dPvGX.useFilter)();
    const projectType = filter[(0, $gkT9B.FilterFields).ProjectType];
    const { jira: jira } = (0, $8Uumt.useFragment)((0, $eGjK2.default), dataRef);
    const projectTypeInfo = (0, $hzYon.getProjectTypeInfo)(projectType);
    const { recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey } = projectTypeInfo;
    const handleCreate = (0, $5uXOq.useCallback)((open)=>{
        open({
            isNextGen: false,
            showExperienceSelection: false,
            recommendedTemplate: recommendedTemplate,
            isTemplatePickerOpenInitially: true,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            selectedProjectType: projectType,
            defaultSelectedTemplateKey: defaultSelectedTemplateKey
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'CreateProjectButton');
    }, [
        analyticsEvent,
        defaultSelectedTemplateKey,
        projectType,
        recommendedTemplate
    ]);
    if (!jira?.canCreateProject || !projectTypeInfo?.projectType) return projectType === (0, $2vSU6.CORE_PROJECT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($99jR2))),
        header: formatMessage((0, $cSPVK.default).jiraCoreHeading),
        description: formatMessage((0, $cSPVK.default).businessEmptyStateContactAdminDescription)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($lIPB5))),
        header: formatMessage((0, $cSPVK.default).defaultEmptyMessage),
        description: formatMessage((0, $cSPVK.default).defaultEmptyMessageDescription),
        headingLevel: 2
    });
    const { imageUrl: imageUrl, heading: heading, description: description } = projectTypeInfo;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKCrm.ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
            imageUrl: imageUrl,
            header: formatMessage(heading),
            description: formatMessage(description),
            primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "primary",
                onClick: ()=>handleCreate(open)
            }, formatMessage((0, $cSPVK.default).createProjectPrompt))
        }));
};

});
parcelRegister("eGjK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b26361e0ff1b1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dbb3ef517e2cfc207434466c963173be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d70b26361e0ff1b1$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "emptyView_projectsDirectoryV3",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "alias": "canCreateProject",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ]
        }
    ],
    "type": "Query"
};
$d70b26361e0ff1b1$var$node.hash = "64aed467ff12136f85c955e02911e4a5";
var $d70b26361e0ff1b1$export$2e2bcd8739ae039 = $d70b26361e0ff1b1$var$node;

});

parcelRegister("99jR2", function(module, exports) {
module.exports = new URL("briefcase.d6e3da3b.svg", import.meta.url).toString();

});

parcelRegister("lIPB5", function(module, exports) {
module.exports = new URL("empty.5f4c2076.svg", import.meta.url).toString();

});

parcelRegister("cSPVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d187464412e2bf9f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d187464412e2bf9f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jiraSoftwareHeading: {
        "id": "projects-directory-v3.page-layout.empty-view.jira-software-heading",
        "defaultMessage": "You don't have any software projects"
    },
    jiraSoftwareDescription: {
        "id": "projects-directory-v3.page-layout.empty-view.jira-software-description",
        "defaultMessage": "Create a new software project to plan, track, and release great software with your team."
    },
    jiraServiceManagementHeading: {
        "id": "projects-directory-v3.page-layout.empty-view.jira-service-management-heading",
        "defaultMessage": "You don\u2019t have any service projects"
    },
    jiraServiceManagementDescription: {
        "id": "projects-directory-v3.page-layout.empty-view.jira-service-management-description",
        "defaultMessage": "Create a new service project to give your customers a place to ask for help, report incidents, and request new services."
    },
    jiraCoreHeading: {
        "id": "projects-directory-v3.page-layout.empty-view.jira-core-heading",
        "defaultMessage": "You don't have any business projects"
    },
    jiraCoreDescription: {
        "id": "projects-directory-v3.page-layout.empty-view.jira-core-description",
        "defaultMessage": "Create a new business project to manage tasks, monitor details, and measure performance with your team."
    },
    jiraProductDiscoveryHeading: {
        "id": "projects-directory-v3.page-layout.empty-view.jira-product-discovery-heading",
        "defaultMessage": "You don't have any product discovery projects"
    },
    jiraProductDiscoveryDescription: {
        "id": "projects-directory-v3.page-layout.empty-view.jira-product-discovery-description",
        "defaultMessage": "Create a new product discovery project to collect insights and ideas to define and prioritize upcoming work for your team."
    },
    createProjectPrompt: {
        "id": "projects-directory-v3.page-layout.empty-view.create-project-prompt",
        "defaultMessage": "Create project"
    },
    businessEmptyStateContactAdminDescription: {
        "id": "projects-directory-v3.page-layout.empty-view.business-empty-state-contact-admin-description",
        "defaultMessage": "Contact your admin to create a business project"
    },
    defaultEmptyMessage: {
        "id": "projects-directory-v3.page-layout.empty-view.default-empty-message",
        "defaultMessage": "No projects were found that match your search"
    },
    defaultEmptyMessageDescription: {
        "id": "projects-directory-v3.page-layout.empty-view.default-empty-message-description",
        "defaultMessage": "Try using specific project names or terms."
    }
});

});

parcelRegister("hzYon", function(module, exports) {

$parcel$export(module.exports, "getProjectTypeInfo", () => $0721d96d9ccf3b2d$export$f1e0682732f2506b);

var $4Pf62 = parcelRequire("4Pf62");

var $99jR2 = parcelRequire("99jR2");

var $eEUs2 = parcelRequire("eEUs2");

var $1hdeU = parcelRequire("1hdeU");

var $cSPVK = parcelRequire("cSPVK");
const { JIRA_SOFTWARE: $0721d96d9ccf3b2d$var$JIRA_SOFTWARE, JIRA_SERVICEDESK: $0721d96d9ccf3b2d$var$JIRA_SERVICEDESK, JIRA_CORE: $0721d96d9ccf3b2d$var$JIRA_CORE, JIRA_PRODUCT_DISCOVERY: $0721d96d9ccf3b2d$var$JIRA_PRODUCT_DISCOVERY } = (0, $4Pf62.LICENSED_PRODUCTS);
const $0721d96d9ccf3b2d$export$f1e0682732f2506b = (projectType)=>{
    switch(projectType){
        case 'software':
            return {
                projectType: projectType,
                product: $0721d96d9ccf3b2d$var$JIRA_SOFTWARE,
                heading: (0, $cSPVK.default).jiraSoftwareHeading,
                description: (0, $cSPVK.default).jiraSoftwareDescription,
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($eEUs2))),
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: undefined
            };
        case 'service_desk':
            return {
                projectType: projectType,
                product: $0721d96d9ccf3b2d$var$JIRA_SERVICEDESK,
                heading: (0, $cSPVK.default).jiraServiceManagementHeading,
                description: (0, $cSPVK.default).jiraServiceManagementDescription,
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($1hdeU))),
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: undefined
            };
        case 'business':
            return {
                projectType: projectType,
                product: $0721d96d9ccf3b2d$var$JIRA_CORE,
                heading: (0, $cSPVK.default).jiraCoreHeading,
                description: (0, $cSPVK.default).jiraCoreDescription,
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($99jR2))),
                recommendedTemplate: {
                    templateKey: 'com.atlassian.jira-core-project-templates:jira-core-simplified-project-management',
                    isSimplified: false
                },
                defaultSelectedTemplateKey: undefined
            };
        case 'product_discovery':
            return {
                projectType: projectType,
                product: $0721d96d9ccf3b2d$var$JIRA_PRODUCT_DISCOVERY,
                heading: (0, $cSPVK.default).jiraProductDiscoveryHeading,
                description: (0, $cSPVK.default).jiraProductDiscoveryDescription,
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($eEUs2))),
                recommendedTemplate: {
                    templateKey: 'jira.polaris:discovery',
                    isSimplified: false
                },
                defaultSelectedTemplateKey: 'jira.polaris:discovery'
            };
        default:
            return {};
    }
};

});
parcelRegister("eEUs2", function(module, exports) {
module.exports = new URL("jira-laptop-done.35194f30.svg", import.meta.url).toString();

});

parcelRegister("1hdeU", function(module, exports) {
module.exports = new URL("service-bell-window.638bf1d2.svg", import.meta.url).toString();

});




//# sourceMappingURL=async-project-directory-empty-view.6eca8fff.js.map
